export enum Roles {
    
    Undefined = 'Undefined',
    
    /**
     * Usuário anônimo, não preencheu NENHUM passo do cadastro
     */
    Anonymous = 'Anonymous' ,
    
    /**
     * Usuário está em preenchimento do cadastro, já completo o passo BASE ( E-mail, telefone, nome ) ou mais passos.
     */
    Identified = 'Identified',

    /**
     * Cadastro e documentos enviados e aprovados
     */
    Registered = 'Registered',
    
    /**
     * Já colocou dinheiro na conta ( já realizou a primeira transferencia )
     */
    Activated = 'Activated',
    
    /**
     * Procurador
     */
    Attorney = 'Attorney',
    
    /**
     * Emissor
     */
    Emitter = 'Emitter'

}